import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Eye, Users, ChartLineUp, Pulse } from "@phosphor-icons/react";

const Card = ({ label, value, icon, accent }) => (
  <div className="border border-white/10 p-5" data-testid={`stat-${label.replace(/\s+/g,'-').toLowerCase()}`}>
    <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/40">
      {icon}
      <span>{label}</span>
    </div>
    <div className={`mt-3 font-display text-4xl leading-none ${accent ? "text-[#FF3B00]" : "text-white"}`}>
      {value}
    </div>
  </div>
);

export default function LiveAnalytics() {
  const [live, setLive] = useState({ online: 0 });
  const [stats, setStats] = useState({ unique: {}, views: {}, top_pages: [] });

  const fetchLive = () =>
    api.get("/admin/analytics/live").then((r) => setLive(r.data)).catch(() => {});
  const fetchStats = () =>
    api.get("/admin/analytics/stats").then((r) => setStats(r.data)).catch(() => {});

  useEffect(() => {
    fetchLive();
    fetchStats();
    const t1 = setInterval(fetchLive, 15000);
    const t2 = setInterval(fetchStats, 60000);
    return () => { clearInterval(t1); clearInterval(t2); };
  }, []);

  return (
    <div className="mt-6" data-testid="live-analytics">
      <div className="flex items-center gap-3 mb-4">
        <span className="inline-flex h-2 w-2 rounded-full bg-[#FF3B00] animate-pulse" />
        <div className="text-xs uppercase tracking-[0.3em] text-[#FF3B00]">Trafic en direct</div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card label="En ligne maintenant" value={live.online ?? 0} icon={<Pulse size={14} weight="bold" />} accent />
        <Card label="Visiteurs aujourd'hui" value={stats.unique?.day ?? 0} icon={<Users size={14} weight="bold" />} />
        <Card label="Visiteurs 7 jours" value={stats.unique?.week ?? 0} icon={<Users size={14} weight="bold" />} />
        <Card label="Pages vues 7 jours" value={stats.views?.week ?? 0} icon={<Eye size={14} weight="bold" />} />
      </div>

      <div className="mt-6 border border-white/10 p-5">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/40 mb-4">
          <ChartLineUp size={14} weight="bold" />
          <span>Top pages (7 derniers jours)</span>
        </div>
        {stats.top_pages?.length ? (
          <ul className="divide-y divide-white/5">
            {stats.top_pages.map((p) => (
              <li key={p.path} className="flex justify-between items-center py-3 text-sm">
                <span className="text-white/80 font-mono truncate mr-4">{p.path || "/"}</span>
                <span className="text-[#FF3B00] font-bold">{p.views}</span>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-sm text-white/40 italic">Aucune donnée encore — reviens dans quelques minutes.</div>
        )}
      </div>
    </div>
  );
}
